// context/MaterialContext.js
import React, { createContext, useState,useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const NavigationTabContext = createContext();

export function NavigationTabContextProvider({ children }) {
  const [selectedNavigationTab, setSelectedNavigationTab] = useState("home");
  const navigate = useNavigate()
  const location = useLocation()

  const customNavigate = (baseUrl,destinationPath,navigationItem,state={})=>{

    sessionStorage.setItem("lastState", JSON.stringify({
      baseUrl,
      destinationPath,
      navigationItem,
      state
    }));

    setSelectedNavigationTab(navigationItem)
    return navigate(`${baseUrl}/${destinationPath}`,{state:state})
  }

  const onPopState = () => {
    const pathParts = window.location.pathname.split("/"); // ['', 't', 'maintab', 'others']
    console.log(pathParts)
    const tab = pathParts[2]
    setSelectedNavigationTab(tab||"home"); // Your custom navigation logic
    // return navigate(`${pathParts[1]}/${tab}/${pathParts[3]||""}`,{ replace: false })
  };


  useEffect(() => {
  const lastStateJson = sessionStorage.getItem("lastState");

  if (lastStateJson) {
    const { baseUrl, destinationPath, navigationItem, state } = JSON.parse(lastStateJson);
    console.log("Restoring from sessionStorage:", baseUrl, destinationPath, navigationItem, state);

    customNavigate(baseUrl, destinationPath, navigationItem, state);
  } else {
    // Fallback: just update the tab from the URL path
    const pathParts = window.location.pathname.split("/");
    const tab = pathParts[2];
    setSelectedNavigationTab(tab||"home");
  }
}, []);

  useEffect(() => {
    window.addEventListener("popstate", onPopState);
    window.addEventListener("beforeunload", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
      window.removeEventListener("beforeunload", onPopState);
    };
  }, []);


  return (
    <NavigationTabContext.Provider value={{ selectedNavigationTab, setSelectedNavigationTab, customNavigate }}>
      {children}
    </NavigationTabContext.Provider>
  );
}


// context/MaterialContext.js
// import React, { createContext, useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';

// export const NavigationTabContext = createContext();

// export function NavigationTabContextProvider({ children }) {
//   const [selectedNavigationTab, setSelectedNavigationTab] = useState("home");
//   const navigate = useNavigate();
//   const location = useLocation();

//   const customNavigate = (baseUrl, destinationPath, navigationItem, state = {}) => {
//     setSelectedNavigationTab(navigationItem);
//     return navigate(`${baseUrl}/${destinationPath}`, { state });
//   };

//   // Parse current path to update active tab
//   const parseTabFromPath = (path) => {
//     const pathParts = path.split("/");
//     console.log("path parts: ",pathParts)
//     return pathParts[2] || "home";
//   };

//   // When route changes via any means (navigate, Link click, back/forward)
//   useEffect(() => {
//     const tab = parseTabFromPath(location.pathname);
//     setSelectedNavigationTab(tab);
//     // navigate(`${baseUrl}/${destinationPath}`, { state:location.state })
//     return ;
//   }, [location.pathname]);

//   // Before page refresh or close
//   useEffect(() => {
//     const handleBeforeUnload = () => {
//       const tab = parseTabFromPath(window.location.pathname);
//       setSelectedNavigationTab(tab);
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, []);

//   return (
//     <NavigationTabContext.Provider value={{ selectedNavigationTab, setSelectedNavigationTab, customNavigate }}>
//       {children}
//     </NavigationTabContext.Provider>
//   );
// }
